import { RecruitItem } from "components/atoms/recruit/RecruitItem"
import React from "react"
import styled from "styled-components"

import type { Recruit } from "interfaces/RecruitIF"

const StyledDiv = styled.div`
  display: block;
  width: 100%;
  padding: 4rem 0;
`
type RecruitContainerProps = {
  recruits: Recruit[]
} & React.ComponentProps<typeof StyledDiv>

export const RecruitContainer = React.memo(function recruitContainer({
  recruits,
  ...props
}: RecruitContainerProps) {
  return (
    <StyledDiv {...props}>
      {recruits &&
        recruits.map((recruit) => {
          return <RecruitItem recruit={recruit} key={recruit.recruitId} />
        })}
    </StyledDiv>
  )
})
